import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function GetGrouped(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    url: `${BASE_URL}/api/group`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
export async function GetCusWithin(salesOrg: string, customerNum: string, plant: string, miles: number, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      plant,
      miles,
    },
    data: {
      group: data
    },
    url: `${BASE_URL}/api/group/getCusWithin`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
export async function GetCus(salesOrg: string, customerNum: string, plant: string, searchCustNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      plant,
      searchCustNum,
    },
    url: `${BASE_URL}/api/group/getCus`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}

export async function PostGrouped(salesOrg: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      group: data,
    },
    url: `${BASE_URL}/api/group/save`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}

export default async function DeleteGroup(salesOrg: string, groupGuid: string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      groupGuid,
    },
    url: `${BASE_URL}/api/group/delete`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
